import { useTranslation } from "next-i18next";
import Image from "next/image";

const CloudServersAdvantages = () => {
    const { t } = useTranslation(["common", "cloudServer"]);

    return (
        <div className="container py-12 mx-auto lg:py-24">
            <h2 className="relative z-10 text-3xl font-bold text-center lg:text-4xl text-titleColor text-after-shadow-cloud2">{t("cloudServer:cloudServersAdvantages")}</h2>

            <div className="grid items-center px-4 pt-12 lg:grid-cols-2">
                <div>
                    <Image src={"/flexibilityAndScalability.png"} width={407} height={380} alt={t("cloudServer:cloudServersAdvantages")} title={t("cloudServer:cloudServersAdvantages")} />
                </div>

                <div>
                    <h3 className="my-4 text-2xl font-bold text-titleColor lg:text-3xl">{t("cloudServer:flexibilityAndScalability")}</h3>
                    <div className=" text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:flexibilityAndScalabilityDesc") }}></div>

                    <div className="flex py-4 space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i> <p className="text-textGray">{t("cloudServer:flexibilityAndScalabilityDesc2")}</p>
                    </div>

                    <div className="flex py-4 space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i> <p className="text-textGray">{t("cloudServer:flexibilityAndScalabilityDesc3")}</p>
                    </div>

                    <div className="flex py-4 space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i> <p className="text-textGray">{t("cloudServer:flexibilityAndScalabilityDesc4")}</p>
                    </div>

                    <div className="pt-4 text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:flexibilityAndScalabilityDesc5") }}></div>
                </div>
            </div>

            <div className="grid items-center px-4 pt-12 lg:grid-cols-2 gap-x-80">
                <div>
                    <h3 className="my-4 text-2xl font-bold text-titleColor lg:text-3xl">{t("cloudServer:lowerCoast")}</h3>
                    <div className=" text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:lowerCoastDesc") }}></div>

                    <div className="flex py-4 space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i> <p className="text-textGray">{t("cloudServer:lowerCoastDesc2")}</p>
                    </div>

                    <div className="flex py-4 space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i> <p className="text-textGray">{t("cloudServer:lowerCoastDesc3")}</p>
                    </div>

                    <div className="flex py-4 space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i> <p className="text-textGray">{t("cloudServer:lowerCoastDesc4")}</p>
                    </div>

                    <p className="pt-4 text-textGray">{t("cloudServer:lowerCoastDesc5")}</p>
                </div>

                <div>
                    <Image src={"/lowerCost.png"} width={434} height={406} alt={t("cloudServer:lowerCoast")} title={t("cloudServer:lowerCoast")} />
                </div>
            </div>

            <div className="grid items-center px-4 pt-12 lg:grid-cols-2 gap-x-80 ">
                <div className="order-2 lg:order-1">
                    <Image src={"/highAvailability.png"} width={434} height={406} alt={t("cloudServer:highAvailabilityAndSecurity")} title={t("cloudServer:highAvailabilityAndSecurity")} />
                </div>

                <div className="order-1 lg:order-2">
                    <h3 className="my-4 text-2xl font-bold text-titleColor lg:text-3xl">{t("cloudServer:highAvailabilityAndSecurity")}</h3>
                    <div className=" text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:highAvailabilityAndSecurityDesc") }}></div>

                    <div className="flex py-4 space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i> <p className="text-textGray">{t("cloudServer:highAvailabilityAndSecurityDesc2")}</p>
                    </div>

                    <div className="flex py-4 space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i> <p className="text-textGray">{t("cloudServer:highAvailabilityAndSecurityDesc3")}</p>
                    </div>

                    <div className="flex py-4 space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i> <p className="text-textGray">{t("cloudServer:highAvailabilityAndSecurityDesc4")}</p>
                    </div>

                    <p className="pt-4 text-textGray">{t("cloudServer:highAvailabilityAndSecurityDesc5")}</p>
                </div>
            </div>

            <div className="grid items-center px-4 pt-12 lg:grid-cols-2 gap-x-80">
                <div>
                    <h3 className="my-4 text-2xl font-bold text-titleColor lg:text-3xl">{t("cloudServer:remoteAccess")}</h3>
                    <div className=" text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:remoteAccessDesc") }}></div>

                    <div className="flex py-4 space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i> <p className="text-textGray">{t("cloudServer:remoteAccessDesc2")}</p>
                    </div>

                    <div className="flex py-4 space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i> <div className="text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:remoteAccessDesc3") }}>{ }</div>
                    </div>

                    <div className="flex py-4 space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i> <p className="text-textGray">{t("cloudServer:remoteAccessDesc4")}</p>
                    </div>

                    <div className="pt-4 text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:remoteAccessDesc5") }}></div>
                </div>

                <div>
                    <Image src={"/remoteAccess.png"} width={420} height={405} alt={t("cloudServer:remoteAccess")} title={t("cloudServer:remoteAccess")} />
                </div>
            </div>

            <div className="grid items-center px-4 pt-12 lg:grid-cols-2 gap-x-80">
                <div className="order-2 lg:order-1">
                    <Image src={"/highPerformanceAndSpeed.png"} width={420} height={405} alt={t("cloudServer:highPerformanceAndSpeed")} title={t("cloudServer:highPerformanceAndSpeed")} />
                </div>

                <div className="order-1 lg:order-2">
                    <h3 className="my-4 text-2xl font-bold text-titleColor lg:text-3xl">{t("cloudServer:highPerformanceAndSpeed")}</h3>
                    <div className=" text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:highPerformanceAndSpeedDesc") }}></div>

                    <div className="flex py-4 space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i> <p className="text-textGray">{t("cloudServer:highPerformanceAndSpeedDesc2")}</p>
                    </div>

                    <div className="flex py-4 space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i> <p className="text-textGray">{t("cloudServer:highPerformanceAndSpeedDesc3")}</p>
                    </div>

                    <div className="flex py-4 space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i> <p className="text-textGray">{t("cloudServer:highPerformanceAndSpeedDesc4")}</p>
                    </div>

                    <p className="pt-4 text-textGray">{t("cloudServer:highPerformanceAndSpeedDesc5")}</p>
                </div>
            </div>
        </div>
    )
}

export default CloudServersAdvantages